import { TableProps } from 'antd';
import { FC } from 'react';
import { NewStyledTable, StyledTable } from './Table.styles';

const Table: FC<
    TableProps<any> & {
        newUi?: boolean;
    }
> = (props) => {
    if (props.newUi) return <NewStyledTable {...props} />;
    return <StyledTable {...props} />;
};
export default Table;
